import { Types } from "../constants/actionTypes";

const initialState = {
  movementList: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_MOVEMENT_LIST:
      return {
        ...state,
        movementList: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
